import {useState} from 'react';
import {TwoFactorChallengePage} from '@common/auth/ui/two-factor/two-factor-challenge-page';
import {LoginPageWPhone} from "@common/auth/ui/login-page-w-phone";

export function LoginPageWrapper() {
  const [isTwoFactor, setIsTwoFactor] = useState(false);
  if (isTwoFactor) {
    return <TwoFactorChallengePage />;
  } else {
    return <LoginPageWPhone onTwoFactorChallenge={() => setIsTwoFactor(true)} />;
  }
}
